import React from "react";
import { TranscriptMessageViewModel } from "./TranscriptViewModel";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import Paper from "@mui/material/Paper";
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import PersonIcon from '@mui/icons-material/Person';
import Avatar from "@mui/material/Avatar";
import TranscriptLine from "./TranscriptLine";
import TranscriptTextFinder from "./TranscriptTextFinder";
import TranscriptSearch from "./TranscriptSearch";

const styles = {
    agentAvatar: {
        backgroundColor: '#1d8abf', height: "30px", width: "30px"
    },
    customerAvatar: {
        backgroundColor: '#3bb7b2', height: "30px", width: "30px"
    },
    avatarIcon: {
        color: 'white', height: "22px", width: "22px"
    },
    agentBackground: {
        backgroundColor: "#1d8abf1c"
    },
    customerBackground: {
        backgroundColor: "#38b9b421"
    },
}
interface ITranscriptMessageProps {
    message: TranscriptMessageViewModel
    agentName: string
    customerName: string
    transcriptSearch?: TranscriptSearch
    textFinderViewModel?: TranscriptTextFinder
    messageIndex: number;
    lastMessage: boolean;
}

export default function TranscriptMessage(props: ITranscriptMessageProps) {

    const lines = props.message.lines.map((line, index) => <TranscriptLine
        line={line}
        key={index}
        channel={props.message.isAgent ? "Agent" : "Customer"}
        transcriptSearch={props.transcriptSearch}
        textFinderViewModel={props.textFinderViewModel}
        messageIndex={props.messageIndex}
        lineIndex={index} />)

    return (
        <Grid size={12} container spacing={1} maxWidth="100%" direction={props.message.isAgent ? "row-reverse" : "row"} paddingBottom={props.lastMessage ? 5 : 0}>
            <Grid size="auto">
                {props.message.isAgent ?
                    <Tooltip title="Agent" placement="top">
                        <Avatar style={styles.agentAvatar} variant="rounded">
                            <HeadsetMicIcon style={styles.avatarIcon} />
                        </Avatar>
                    </Tooltip>
                    :
                    <Tooltip title="Customer" placement="top">
                        <Avatar style={styles.customerAvatar} variant="rounded">
                            <PersonIcon style={styles.avatarIcon} />
                        </Avatar>
                    </Tooltip>
                }
            </Grid>
            <Grid container direction={props.message.isAgent ? "row-reverse" : "row"}>
                <Grid>
                    {props.message.isAgent ?
                        <Typography variant="body2" fontSize="12px" textAlign="right">{`${props.agentName} ${props.message.lines[0]?.time}`}</Typography>
                        :
                        <Typography variant="body2" fontSize="12px" >{`${props.customerName} ${props.message.lines[0]?.time}`}</Typography>
                    }
                    <Paper square={false} style={props.message.isAgent ? styles.agentBackground : styles.customerBackground}>
                        {lines}
                    </Paper>
                </Grid>
            </Grid>
            <Grid size={2} />
        </Grid>
    );
}